import { observable } from 'mobx';

export type ProjectResponseArgs = {
  id: number;
  code: string;
  name: string;
};

export type ProjectArgs = {
  id?: number;
  code?: string;
  name?: string;
};

export const convertProjectResponseToArgs = (response: ProjectResponseArgs) => {
  const args: ProjectArgs = {
    id: response.id,
    code: response.code,
    name: response.name
  };
  return args;
};

export default class Project {
  @observable id?: number;
  @observable code?: string;
  @observable name?: string;

  constructor(args: ProjectArgs) {
    this.id = args.id;
    this.code = args.code;
    this.name = args.name;
  }
}
